import { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash';

import Client from './client';
import { ImmigrationMedia, Result } from './types';

type Response = {
  readonly result: Result;
  readonly status: number;
  readonly media: ImmigrationMedia;
  readonly medias: ImmigrationMedia[];
  readonly total: number;
};

export default (
  id: string,
  offset: number = 0,
  limit: number = 10,
  config?: AxiosRequestConfig
) => {
  return Client.get<Response>(
    `/ps/v1/guide/media/previews?guideId=${id}&page=${offset}&size=${limit}`,
    merge(config)
  );
};
